import { Text } from '@lmc/ui-kit'
import React from 'react'

type BillingContactProps = {
  email?: string
  home?: string
}

/**
 * Display the email of the user registered in Chargebee.
 * This person recieves most billing email notifications
 * @param email: string
 * @param home: Name of the home registered in Chargebee
 */
export const BillingContact = ({ email, home }: BillingContactProps) => {
  if (!email) return null
  return (
    <div style={styles.container}>
      <div>
        <Text as="p1">
          <strong>{home}</strong>
        </Text>
      </div>
      <div>
        <Text as="p1" color="darkgrey">
          <strong>Billing contanct:</strong> {email}
        </Text>
      </div>
    </div>
  )
}

const styles = {
  container: { marginBottom: 24 }
}

export default BillingContact
